(function() {
'use strict';

angular
    .module('TR')
    .service('analytics', analytics);

function analytics(
            broker,
            $http,
            $timeout,
            $document,
            $location,
            $q,
            $rootScope,
            $route,
            $routeParams,
            abTest,
            destinationService,
            loggingService,
            searchUnitService,
            currentUser,
            tripService,
            cookieService,
            unadjustedDateFilter) {
    let lastUrl;
    let lastAbs;
    let timer;
    const timers = [];
    const url = '/api2/analytics/';
    const _defer = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.setTimeout;
    const skipAnalytics = (/prerender/i.test(navigator.userAgent) || !TRPCONFIG.Domain.GoogleTagManagerEnabled) && !TRPCONFIG.IsUnitTestForAnalytics;
    const searchTypes = {
        1: 'FlightSearch',
        2: 'HotelSearch',
        3: 'HolidaySearch',
        4: 'TransferSearch',
        6: 'ParkingSearch'
    };
    const service = {
        trackEvent,
        trackTiming,
        trackConversion,
        trackSearchOrigin,
        pageLoad,
        routeChange,
        startTimer,
        endTimer,
        track,
        incrementPeopleEvent,
        trackRequestedHotelNotAvailable,
        setMixpanelEmail
    };

    const noop = function() { return $q.when(); };

    if (skipAnalytics) {
        for (const func in service) {
            service[func] = noop;
        }
    }

    let utmId;
    let _mixPanelReady = subscribeOnceAsPromise('userSet')
        .then(() => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ config: TRPCONFIG });
            utmId = currentUser.get() ? currentUser.get().UtmId : null;
            if (utmId === '') {
                return $q.reject();
            }
        })
        .then(() => {
            window.dataLayer.push({ utmId });
            return TRPCONFIG.MixPanelLoaded || subscribeOnceAsPromise('MixPanelLoaded');
        })
        .then(() => {
            window.mixpanel.register({ 'Device Category': TRPCONFIG.DeviceCategory, 'Platform': `${TRPCONFIG.Domain.DeviceType}Web` });
            window.mixpanel.register({ Domain: extractDomain() });
            window.mixpanel.register({ BookingLanguage: TRPCONFIG.Domain.CultureCode });
            let distinctId = window.mixpanel.get_distinct_id();
            window.mixpanel.identify(distinctId.indexOf('-') > -1 ? utmId : distinctId);
            TRPCONFIG.MixPanelReady = true;
        });

    function extractDomain() {
        let match = window.location.href.match(/([a-z]+.(com|co.uk|ru|ae)\/*[a-z]+_[a-z0-9]+\/)/g);
        if (match) { return match[0]; }
        match = window.location.hostname.match(/\..+\..+/g);
        if (match) { return match[0].slice(1); }
        return window.location.hostname;
    }

    function startTimer(key) {
        const opts = {
            action: key,
            category: 'performance',
            label: 'loading screen timeout'
        };

        if (timers[key] != null) {
            $timeout.cancel(timers[key][0]);
        }
        timers[key] = [
            $timeout(function() {
                trackEvent(opts);
                const utm = currentUser.get().UtmId;
                loggingService.logWarn(`customer with utm ${utm} and userAgent ${navigator.userAgent} experienced a loading screen timeout with key "${opts.action}"`);
            }, 30000), new Date().getTime()
        ];
    }

    function endTimer(key) {
        timer = timers[key];
        if (timer != null) {
            $timeout.cancel(timer[0]);

            const opts = {
                timingCategory: 'performance',
                timingVar: key,
                timingValue: new Date().getTime() - timer[1],
                timingLabel: 'LoadingScreen'
            };

            trackTiming(opts);
            delete timers[key];
        }
    }

    function trackTiming(opts) {
        opts = angular.extend({ timingCategory: 'performance', timingVar: 'timer', timingLabel: null, timingValue: null }, opts || {});
            _defer(function() {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'timingEvent',
                    category: opts.timingCategory,
                    variable: opts.timingVar || '',
                    time: opts.timingValue,
                    label: opts.timingLabel
                });
            });
    }

    function trackEvent(opts) {
        opts = angular.extend({ category: 'button', action: 'click', label: null, value: null }, opts || {});
        _defer(function() {
            window.dataLayer = window.dataLayer || [];
            let obj = {
                event: 'clickEvent',
                category: opts.category,
                action: opts.action,
                value: opts.value,
                label: opts.label
            };
            if (TRPCONFIG.Domain.TenantId === 3) {
                obj = angular.extend(obj, _.pick(opts, 'dimension3', 'dimension4', 'dimension5', 'dimension6', 'dimension7', 'dimension8'));
            }
            window.dataLayer.push(obj);
        });
    }

    function trackConversion(value) {
        if (TRPCONFIG.Domain.GoogleConversionId !== 0) {
            /* eslint-disable camelcase */
            const conversionObject = {
                google_conversion_id: TRPCONFIG.Domain.GoogleConversionId,
                google_conversion_language: 'en',
                google_conversion_color: 'ffffff',
                google_remarketing_only: false,
                google_conversion_value: value || 1,
                google_conversion_format: 1
            };

            if (TRPCONFIG.Domain.GoogleConversionLabel) {
                conversionObject.google_conversion_label = TRPCONFIG.Domain.GoogleConversionLabel;
            }
            if (TRPCONFIG.Domain.GoogleConversionFormat) {
                conversionObject.google_conversion_format = TRPCONFIG.Domain.GoogleConversionFormat;
            }

            if (window.google_trackConversion) {
                window.google_trackConversion(conversionObject);
            }
            /* eslint-enable camelcase */
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'bookingcomplete' });
    }

    function trackSearchOrigin(tripId, requestedUrl) {
        if (TRPCONFIG.Domain.TrackSearchOriginEnabled) {
            return tripService.getTrip(tripId).then(trip => {
                const request = {
                    RequestedUrl: requestedUrl,
                    AcomSearchId: trip && trip.HotelsRequest && trip.HotelsRequest.AvailabilitySearchId,
                    FlightSearchId: trip && trip.FlightsRequest && trip.FlightsRequest.AvailabilitySearchId
                };

                if (request.AcomSearchId || request.FlightSearchId) {
                    return $http.post(`${url}tracksearchorigin`, request, { ignoreErrors: true });
                }
            });
        }
    }

    function pageLoad(pageUrl) {
        _defer(function() {
            $http.post(`${url}trackpageloadtimings`, {
                DomainId: TRPCONFIG.Domain.DomainId,
                Url: pageUrl,
                Timings: window.performance ? window.performance.timing : null
            }, { ignoreErrors: true });

            updateCriteoId();
        });

        const query = $location.search();
        updateSalesForceParameters(query);

        if (query.source != null && query.dlid != null) {
            _defer(function() {
                $http.post(`${url}trackdeeplink`, {
                    DeepLinkId: query.dlid
                }, { ignoreErrors: true });
            });
        }
    }

    function updateSalesForceParameters(queryParams) {
        const hostName = window.location.hostname;
        const cookieDomain = hostName.slice(hostName.indexOf('.'));
        const params = _.pick(queryParams, ['j', 'sfmc_sub', 'l', 'u', 'jb', 'mid', 'e']);
        if (params.j && params.sfmc_sub && params.l && params.jb && params.mid && params.u) {
            const salesForceParams = _.entries(params).map(([key, value]) => {
                delete queryParams[key];
                return `${key}=${value}`;
            }).join('&');
            cookieService.set('salesforce', salesForceParams, null, cookieDomain);
            $location.search(queryParams);
        }
    }

    function updateCriteoId() {
        const ctoOptOut = cookieService.get('cto_optout');
        const optOut = ctoOptOut === '1';
        const criteoId = optOut ? '' : cookieService.get('cto_axid');

        if (optOut || criteoId) {
            $http.post(`${url}updatecriteoid`, {
                   CriteoId: criteoId,
                   OptOut: optOut
               }, {
                   ignoreErrors: true
               });
        }
    }

    function routeChange(absUrl, relUrl) {
        //double check that the route has actually changed because we suspect that this may
        //get called repeatedly when we go into an infinite digest loop which we have not yet resolved.
        if (relUrl === lastUrl) {
            return;
        }
        lastUrl = relUrl;

        if (relUrl && relUrl === '/' || relUrl === '/v2/') {
            track('mixpanel', 'HomePage');
            _mixPanelReady.then(() => window.mixpanel.people.increment('Home Page Visit'));
        }

        _defer(function() {
            const pages = ['Choose your Hotel', 'Choose your Room', 'Choose your Flight', 'Customize your Holiday', 'Complete your Booking', 'Booking Complete'];
            const flightSelectedPages = ['Customize your Holiday', 'Complete your Booking', 'Booking Complete'];
            window.dataLayer = window.dataLayer || [];
            let pageNm = ($route.current && $route.current.$$route && $route.current.$$route.analyticsTag) ? $route.current.$$route.analyticsTag : '';
            const timeout = pageNm === pages[0] ? 5000 : 500;
            setTimeout(() => {
            pageNm = relUrl === '/' ? 'Home' : pageNm;
            if (!pageNm) {
                const cmsPath = ($route.current && $route.current.locals && $route.current.locals.$scope && $route.current.locals.$scope.cc &&
                $route.current.locals.$scope.cc.template) ? $route.current.locals.$scope.cc.template : '';
                relUrl = cmsPath.includes('cms/page/') ? cmsPath.replace('cms/page/', '') : cmsPath;
                let cmsPageName = relUrl.length > 1 && relUrl.includes('/') ? relUrl.split('/') : relUrl;
                pageNm = cmsPageName.length ? cmsPageName[cmsPageName.length - 1] : cmsPageName;
            }
            const sessionUrls = JSON.parse(sessionStorage.getItem('URLstorage') || '{}');
            const skywardsLoginUser = JSON.parse(sessionStorage.getItem('skywardsLoginUser') || '{}');
            let prevPageName = sessionUrls.previousPage;
            const searchHotelData = JSON.parse(sessionStorage.getItem('hotelSearchResults') || '{}');
            const hotelData = JSON.parse(sessionStorage.getItem('hotelData') || '{}');
            const defaultFlight = JSON.parse(sessionStorage.getItem('DefaultFlight') || '{}');
            const defaultFlightDetails = JSON.parse(sessionStorage.getItem('storeSelectedFlight')) ?
            JSON.parse(sessionStorage.getItem('storeSelectedFlight')) : (defaultFlight && defaultFlight.Details) ?
            defaultFlight.Details.Itinerary : null;
            const passengers = JSON.parse(sessionStorage.getItem('priceQtys')) ?
            JSON.parse(sessionStorage.getItem('priceQtys')) : defaultFlightDetails;
            let paxType = '';
            if (passengers && passengers.AdultFareQuantity) {
                for (let i = 0; i < passengers.AdultFareQuantity; i++) {
                    paxType = paxType.concat('Adult+');
                }
                for (let i = 0; i < passengers.ChildFareQuantity; i++) {
                    paxType = paxType.concat('Child+');
                }
                for (let i = 0; i < passengers.InfantFareQuantity; i++) {
                    paxType = paxType.concat('Infant+');
                }
            }
            const destCountry = JSON.parse(sessionStorage.getItem('destinationAirports') || '{}');
            let hotelChosen = null;
            if ($routeParams.estabId) {
                hotelChosen = searchHotelData.filter(function(hData) {
                    return hData.Id.toString() === $routeParams.estabId;
                });
            }
            let estabTitle = (pageNm === pages[0]) ? '' : hotelChosen && hotelChosen.length ? hotelChosen[0].Title : hotelData ? hotelData.Title : '';
            if (pages.includes(pageNm)) {
                if ($routeParams.tripId) {
                    tripService.getTrip($routeParams.tripId).then(trip => {
                        tripService.getTripNumberOfNights(1, $routeParams.tripId).then(duration => {
                        const depAirport = defaultFlightDetails && defaultFlightDetails.Legs ? defaultFlightDetails.Legs[0].DepartureAirport.Code :
                                            (trip && trip.FlightsRequest) ? trip.FlightsRequest.SelectedDepartureAirport.Code : '';
                        const destAirport = defaultFlightDetails && defaultFlightDetails.Legs ? defaultFlightDetails.Legs[0].ArrivalAirport.Code :
                                            (trip && trip.FlightsRequest) ? trip.FlightsRequest.DestinationAirports : '';
                        const destCity = (destCountry.Airports.length && destCountry.Airports[0].Title && destCountry.Airports[0].Title.includes(', ')) ?
                                        destCountry.Airports[0].Title.split(', ')[0] : (trip && trip.FlightsRequest && trip.FlightsRequest.Destination.ShortTitle) ?
                                        trip.FlightsRequest.Destination.ShortTitle.includes('(') ?
                                        trip.FlightsRequest.Destination.ShortTitle.split('(')[0].trim() : trip.FlightsRequest.Destination.ShortTitle : '';
                        const membership = (skywardsLoginUser && skywardsLoginUser.data) ? skywardsLoginUser.data.Contact.Tier : '';
                            window.dataLayer.push(
                                { event: 'virtualPageView',
                                pageName: pageNm,
                                previousPageName: prevPageName,
                                countryCode: TRPCONFIG.Domain.CountryCode,
                                languageCode: TRPCONFIG.SelectedRegionalContext.Language,
                                loginState: (skywardsLoginUser && skywardsLoginUser.status) ? 'logged-in' : 'logged-out',
                                originCountry: TRPCONFIG.Domain.CountryName,
                                destinationCountry: destCountry.Airports && destCountry.Airports[0].Title && destCountry.Airports[0].Title.includes(', ') ?
                                            destCountry.Airports[0].Title.split(', ')[1] : hotelData.Country || searchHotelData.length ? searchHotelData[0].Country : '',
                                originCity: defaultFlightDetails ? defaultFlightDetails.Legs[0].DepartureAirport.Title :
                                            (trip && trip.FlightsRequest) ? trip.FlightsRequest.SelectedDepartureAirport.ShortTitle ?
                                            trip.FlightsRequest.SelectedDepartureAirport.ShortTitle : trip.FlightsRequest.SelectedDepartureAirport.Title : '',
                                destinationCity: hotelData.Province || searchHotelData.length ? searchHotelData[0].Province : destCity ?
                                            (destCity.includes('(') ? destCity.split('(')[0].trim() : destCity) : '',
                                tripDuration: defaultFlightDetails ? defaultFlightDetails.Nights : duration,
                                inboundDate: (trip && trip.FlightsRequest) ? trip.FlightsRequest.DepartureDate : '',
                                ouboundDate: (trip && trip.FlightsRequest) ? trip.FlightsRequest.ReturnDate : '',
                                passengerCount: (trip && trip.FlightsRequest) ? trip.FlightsRequest.Adults + trip.FlightsRequest.ChildAges.length : '',
                                passengerType: paxType.slice(0, -1),
                                numberOfRoom: (trip && trip.HotelsRequest) ? trip.HotelsRequest.Rooms.length : '',
                                hotelSelected: estabTitle,
                                originAirport: flightSelectedPages.includes(pageNm) ? depAirport : '',
                                destinationAirport: flightSelectedPages.includes(pageNm) ? destAirport : '',
                                classOfTravel: defaultFlightDetails ? defaultFlightDetails.Legs[0].CabinType : '',
                                flightRoute: flightSelectedPages.includes(pageNm) ? `${depAirport} - ${destAirport}` : '',
                                skywardsPersonId: (skywardsLoginUser && skywardsLoginUser.data) ? skywardsLoginUser.data.Contact.LoyaltyId : '',
                                skywardsMembershipTier: membership === 'SKYWARDS' ? 'BLUE' : membership
                                });
                            });
                        });
                } else {
                    window.dataLayer.push({ event: 'virtualPageView', pageName: pageNm, virtualPageURL: relUrl });
                }
            } else {
                window.dataLayer.push({ event: 'virtualPageView', pageName: pageNm, virtualPageURL: relUrl });
            }
        }, timeout);

            // abTest.executeTrackingCode('body');

            $http.post(
                'website/monkey/tennis',
                {
                    Url: absUrl,
                    ReferrerUrl: lastAbs == null ? $document[0].referrer : lastAbs
                },
                { ignoreErrors: true }
            ).then(function checkVersionMismatch(res) {
                if (res.data !== TRPCONFIG.CurrentVersion) {
                    _inactivityTime();
                }
            });
            lastAbs = absUrl;
        });
    }

    function track(type, event, props) {
        switch (type) {
            case 'mixpanel':
                _mixPanelTrack(event, props);
                break;

            case 'Search':
                _searchCompleted(event, props);
                break;

            case 'Event':
                _pushTripTypeToDataLayer().then(() => window.dataLayer.push(_.assignIn({ event }, props)));
                break;

            case 'mixpanelPeople':
                _trackPeople(event, props);
                break;

            case 'eCommerce':
                _ecommerce(event, props);
                break;

            case 'eCommercePaypal':
                _ecommercePaypal(event, props);
                break;
        }
    }

    function _ecommerce(event, data) {
        if (TRPCONFIG.Domain2.BookingCompleteEcommerceLogEnabled) {
            console.log('ecommerce data', _collectEcommerceData(event, data));
        }

        if (TRPCONFIG.Domain2.BookingCompleteEcommercePushEnabled) {
            const ecommerceData = _collectEcommerceData(event, data);

            sessionStorage.setItem('eCommercePurchaseData', JSON.stringify(ecommerceData));
        }
    }

    function _ecommercePaypal(event, paypalData) {
        if (TRPCONFIG.Domain2.BookingCompleteEcommerceLogEnabled) {
            console.log('ecommerce paypal data', _collectEcommercePaypalData(event, paypalData));
        }

        if (TRPCONFIG.Domain2.BookingCompleteEcommercePushEnabled) {
            const ecommercePaypalData = _collectEcommercePaypalData(event, paypalData);

            window.dataLayer.push(ecommercePaypalData);
        }
    }

    function _collectEcommerceData(event, data) {
        return {
            event,
            ecommerce: {
                purchase: {
                    actionField: _collectActionData(data, ({ BookingReferences, Trip }) => ({
                        id: BookingReferences.sort()[0],
                        revenue: Math.round(Trip.Bookings.reduce((acc, { Balance }) => acc + Balance.ClientTotalCost, 0) * 100) / 100
                    })),
                    products: _collectProductData(data, ({ Trip }) => Trip.Bookings.map(({ Balance, BookingCore, Itinerary }) => {
                        const { BookingRef } = BookingCore;
                        const category = _getCategoryFromBookingRef(BookingRef);
                        const name = {
                            Accommodation: ({ Stays: [FirstStay] }) => FirstStay.Hotel.Title,
                            Flight: ({ Flights: [OutboundFlight] }) => OutboundFlight.Segments[OutboundFlight.Segments.length - 1].ArrivalAirport.Title,
                            Transfer: ({ Transfers }) => _getTransferName(Transfers),
                            Insurance: ({ Description }) => Description,
                            Car: ({ PickUpPointName, DropOffPointName }) => `${PickUpPointName} ${DropOffPointName}`,
                            Attractions: ({ Tickets: [FirstTicket] }) => FirstTicket.Description,
                            Parking: ({ ParkingSiteName }) => ParkingSiteName
                        }[category](Itinerary);
                        return {
                            id: BookingRef,
                            category,
                            name,
                            price: Balance.ClientTotalCost
                        };
                    }))
                }
            }
        };
    }

    function _collectEcommercePaypalData(event, data) {
        return {
            event,
            ecommerce: {
                purchase: {
                    actionField: _collectActionData(data, data => {
                        const reducedData = data.reduce((acc, { Ref, Cost }) => {
                            acc.id.push(Ref);
                            acc.revenue += Cost;
                            return acc;
                        }, {
                            id: [],
                            revenue: 0
                        });
                        return {
                            id: reducedData.id.sort()[0],
                            revenue: Math.round(reducedData.revenue * 100) / 100,
                        };
                    }),
                    products: _collectProductData(data, data => data.map(({ Cost, Desc, Ref }) => {
                        const category = _getCategoryFromBookingRef(Ref);
                        return {
                            id: Ref,
                            category,
                            name: Desc,
                            price: Cost
                        };
                    }))
                }
            }
        };
    }

    function _collectActionData(data, _collectActionVariations) {
        const variations = _collectActionVariations(data);
        return {
            ...variations,
            affiliation: TRPCONFIG.Domain.DomainId,
            tax: '0',
            shipping: '',
            coupon: ''
        };
    }

    function _collectProductData(data, _collectProductVariations) {
        const variations = _collectProductVariations(data);
        const products = variations.map(variation => ({
            ...variation,
            quantity: 1
        }));
        const holidayCategories = [{ category: 'Accommodation' }, { category: 'Flight' }];
        const holidayComparator = (a, b) => a.category === b.category;
        const holidayCollection = _.intersectionWith(products, holidayCategories, holidayComparator);
        if (holidayCollection.length === holidayCategories.length) {
            const category = 'Holiday';
            const holidayData = holidayCollection.reduce((acc, { id, name, price }) => {
                acc.id.push(id);
                acc.name.push(name);
                acc.price += price;
                return acc;
            }, {
                id: [],
                name: [],
                price: 0,
            });
            return _.concat({
                id: holidayData.id.join('|'),
                category,
                name: holidayData.name.join('|'),
                price: Math.round(holidayData.price * 100) / 100,
                quantity: 1
            }, _.differenceWith(products, holidayCategories, holidayComparator));
        }
        return products;
    }

    function _getCategoryFromBookingRef(bookingRef) {
        return {
            ACM: 'Accommodation',
            SCH: 'Flight',
            EUF: 'Flight',
            TRN: 'Transfer',
            INS: 'Insurance',
            AUT: 'Car',
            OLF: 'Attractions',
            PRK: 'Parking'
        }[_getBookingPrefixFromBookingRef(bookingRef)];
    }

    function _getBookingPrefixFromBookingRef(bookingRef) {
        return bookingRef.match(/[a-zA-Z]+/g)[0];
    }

    function _getTransferName([itinerary]) {
        if (itinerary.DropOffPoint && itinerary.PickUpPoint) {
            return `${itinerary.DropOffPoint.ResortName} | Return`;
        }
        if (itinerary.DropOffPoint) {
            return `${itinerary.DropOffPoint.ResortName} | One way (Resort to Airport)`;
        }
        if (itinerary.PickUpPoint) {
            return `${itinerary.PickUpPoint.AirportName} | One way (Airport to Resort)`;
        }
    }

    function _pushTripTypeToDataLayer() {
        const tripId = $route && $route.current && $route.current.params && $route.current.params.tripId;
        if (tripId) {
            return tripService.getTrip(tripId).then(t => {
                if (t && t.TripType) {
                    window.dataLayer.push({ tripType: t.TripType });
                }
            });
        }
        return $q.when();
    }

    function _searchCompleted(event, props) {
        const config = {
            event: searchTypes[event],
            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
            CountryCode: TRPCONFIG.Domain.CountryCode
        };

        window.dataLayer.push(_.assignIn(config, props));
    }

    let mixPanelBookingInfoPropsCache = {};

    function _mixPanelTrack(event, props) {
        _mixPanelReady.then(() => {
            if (props == null) {
                window.mixpanel.track(event);
            } else {
                let formattedProps;

                switch (event) {
                    case 'Search':
                        formattedProps = _formatMixpanelSearch(props);
                        break;
                    case 'BookingComplete':
                    case 'BookingForm':
                        mixPanelBookingInfoPropsCache = formattedProps = _formatMixpanelBookingInfo(props);
                        break;
                    case 'FormValidation':
                        formattedProps = _formatMixpanelFormValidation(props, mixPanelBookingInfoPropsCache);
                        break;
                    default:
                        formattedProps = _flattenObject(props);
                }

                window.mixpanel.track(event, formattedProps);
            }
        });
    }

    function _flattenObject(obj) {
        const newObj = {};

        if (typeof obj !== 'object') {
            return obj;
        }

        for (const i in obj) {
            if (!obj.hasOwnProperty(i)) {
                continue;
            }

            if (Array.isArray(obj[i])) {
                newObj[i] = [];
                for (let j = 0; j < obj[i].length; j++) {
                    newObj[i].push(_flattenObject(obj[i][j]));
                }
            } else if ((typeof obj[i]) === 'object') {
                const flatObject = _flattenObject(obj[i]);
                for (const x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) {
                        continue;
                    }
                    newObj[`${i}.${x}`] = flatObject[x];
                }
            } else {
                newObj[i] = obj[i];
            }
        }
        return newObj;
    }

    function _formatMixpanelSearch(search) {
        const counts = { Adults: 0, Children: 0, Rooms: 0 };
        const Nights = search.Nights;
        const DepartureAirports = search.DepartureAirports;
        const TypeTitle = search.TypeTitle;
        const Destination = _.pick(search.Destination, 'CountryId', 'LocationId', 'PlaceId', 'PolygonId', 'ProvinceId', 'EstablishmentId', 'ShortTitle');
        const dateTimeFormat = 'dd MMM yyyy HH:mm';
        const FromDate = search.FromDate ? unadjustedDateFilter(search.FromDate.Date, dateTimeFormat) : undefined;
        const ToDate = search.ToDate ? unadjustedDateFilter(search.ToDate.Date, dateTimeFormat) : undefined;

        if (search.Rooms) {
            search.Rooms.reduce((c, r) => {
                c.Adults += r.Adults;
                c.Children += (r.ChildAges || []).length;
                c.Rooms += 1;
                return c;
            }, counts);
        }

        const result = _.assignIn({
            Nights,
            TypeTitle,
            DepartureAirports,
            FromDate,
            ToDate,
        }, counts, Destination);

        if (search.SearchType === 3 || search.SearchType === 1) {
            const cabinId = search.Cabin || _.get(search, 'searchModel.cabin');
            result.Cabin = ({ 1: 'Economy', 2: 'PremiumEconomy', 8: 'Business', 4: 'First' })[cabinId];

            result.FlexibleDates = _.get(search, 'searchModel.flexibleDates');
            if (angular.isUndefined(result.FlexibleDates)) {
                result.FlexibleDates = searchUnitService.flexibleDates;
            }

            if (search.searchModel) {
                result.CarrierAirlines = _.map(search.searchModel.airlines, a => a.Title);
                result.DirectFlightsOnly = search.searchModel.prefilterDirectFlights;
            }
        }

        return result;
    }

    function _formatMixpanelBookingInfo(data) {
        const result = {
            TotalCost: data.TotalCost,
            HasHotel: !!(data.Hotel && data.Hotel.ProductId),
            HasFlight: !!(data.Flight && data.Flight.ProductId),
            HasBags: !!_.get(data, 'Flight.ProductSpecificFields.OptionCounts.HoldBags'),
            HasSeats: !!_.get(data, 'Flight.ProductSpecificFields.OptionCounts.Seats'),
            HasAttraction: !!(data.Attractions && data.Attractions.length > 0),
            HasCarHire: !!(data.CarHire && data.CarHire.ProductId),
            HasInsurance: !!(data.Insurance && data.Insurance.ProductId),
            HasParking: !!(data.Parking && data.Parking.ProductId),
            HasTransfer: !!(data.Transfer && data.Transfer.ProductId),
            HasMarhaba: !!(data.Marhaba && data.Marhaba.ProductId),
            PageVersion: data.PageVersion || null, //not on BookingComplete props
            Source: data.Source || 'default'
        };

        if (result.HasTransfer === true) {
            result.TransferCostTotal = _.reduce(data.Transfer.CostBreakdown,
                                                (result, v) => result + (v.UnitAmount * v.Quantity),
                                                0
                                               );
        }
        return result;
    }

    function _formatMixpanelFormValidation(props, mixPanelBookingInfoPropsCache) {
        const result = _.merge({}, mixPanelBookingInfoPropsCache);
        const uniqueErrors = {};
        iterate(props.form, 0);
        result.ValidationFail = Object.keys(uniqueErrors);
        _.forEach(props.validationMessages, m => result.ValidationFail.push(m));
        return result;

        function iterate(element, stackDepth) {
            if (element && stackDepth < 5) {
                _.forEach(element.$error, (error, key) => {
                    if (error === true) {
                        key = key.replace('If', '');
                        key = `${key} - ${element.$name}`;
                        uniqueErrors[key] = true;
                    } else {
                        _.forEach(error, iterate, stackDepth + 1);
                    }
                });
            }
        }
    }

    let _inactivityTimeToken;
    function _inactivityTime() {
        if (!_inactivityTimeToken) {
            $(document)
                .on('mousemove', _resetTimer)
                .on('keypress', _resetTimer);
            $(document.body)
                .on('touchstart', _resetTimer)
                .on('touchmove', _resetTimer)
                .on('touchend', _resetTimer);
            _resetTimer();
        }
        function _reload() {
            document.location.reload();
        }
        function _resetTimer() {
            clearTimeout(_inactivityTimeToken);
            _inactivityTimeToken = setTimeout(_reload, 10 * 1000);
        }
    }

    function _trackPeople(event, props) {
        _mixPanelReady.then(() => {
            switch (event) {
                case 'Search':
                    _trackPeopleSearch(props);
                    break;
                case 'BookingComplete':
                    _trackPeopleBookingCompleter(props);
                    break;
            }
        });
    }

    function _trackPeopleSearch(props) {
        window.mixpanel.people.increment('Total Searches');
        window.mixpanel.people.set({ 'Last Search Date': new Date() });
        if (props.Destination) {
            window.mixpanel.people.append('Search terms', props.Destination.ShortTitle ? props.Destination.ShortTitle : props.Destination.Title);
        }
    }

    function _trackPeopleBookingCompleter(props) {
        window.mixpanel.people.increment('Bookings Completed');
        window.mixpanel.people.append('Total value per booking', props.TotalCost);
        window.mixpanel.people.increment('Lifetime value', props.TotalCost);
    }

    function incrementPeopleEvent(event, value = 1) {
        _mixPanelReady.then(() => window.mixpanel.people.increment(event, value));
    }

    function setMixpanelEmail(email) {
        _mixPanelReady.then(() => window.mixpanel.people.set({
            $email: email
        }));
    }

    trackRequestedHotelNotAvailable.idCache = {};
    function trackRequestedHotelNotAvailable(destinationEstabId) {
        if (!trackRequestedHotelNotAvailable.idCache[destinationEstabId]) {
            trackRequestedHotelNotAvailable.idCache[destinationEstabId] = true;
            track('mixpanel', 'RequestedHotelNotAvailable', { destinationEstabId });
        }
    }

    function subscribeOnceAsPromise(topic) {
        return $q(resolve => broker.subscribeOnce('analytics', topic, () => resolve()));
    }

    return service;
}
})();
